import { ItemImage } from '@components/CatalogElements';
import TextCopyToClipboard from '@components/TextCopyToClipboard';
import { MuteText } from '@elements/Common';
import { DarkPopup } from '@elements/Popup';
import { ResponsiveDotts } from '@page-components/dashboard/common';
import { Row } from '@page-components/shipment/ItemsCommon';
import { InfoIcon } from '../styles/common';

export function SKUQuickView({ items }) {
  return (
    <DarkPopup
      contentWidth={500}
      hoverable
      trigger={<InfoIcon className="sk:cursor-pointer" />}
    >
      <div>
        <table
          cellSpacing={0}
          className="sk:w-full sk:[&_td]:border-0 sk:[&_td]:border-t sk:[&_td]:border-solid sk:[&_td]:border-current/20 sk:[&_td]:p-1.25 sk:[&_th]:p-1.25 sk:[&_th]:text-left sk:[&_th]:font-normal"
        >
          <thead>
            <th className="sk:whitespace-nowrap">Product</th>
            <th className="sk:whitespace-nowrap sk:px-5!">&nbsp;</th>
            <th className="sk:whitespace-nowrap">Quantity</th>
          </thead>
          <tbody>
            {items?.map(item => (
              <tr>
                <td>
                  <ItemImage
                    item={{
                      p_images: {
                        display_image: item.image,
                      },
                    }}
                    size="mini"
                    noMargin
                  />
                </td>
                <td>
                  <Row>
                    <MuteText className="sk:mr-2! sk:whitespace-nowrap">
                      SKU
                    </MuteText>
                    <ResponsiveDotts>
                      <TextCopyToClipboard text={item.sku} iconSize={16} />
                    </ResponsiveDotts>
                  </Row>
                  {item.asin && (
                    <Row>
                      <MuteText className="sk:mr-2! sk:whitespace-nowrap">
                        ASIN
                      </MuteText>
                      <ResponsiveDotts>
                        <TextCopyToClipboard text={item.asin} iconSize={16} />
                      </ResponsiveDotts>
                    </Row>
                  )}
                </td>
                <td className="sk:text-center">
                  {item.quantity} <MuteText>Units</MuteText>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DarkPopup>
  );
}
